// Shared bias → Tailwind class mapping for condition chips. Used by the scan results table
// (StepScan) and the manual condition picker so a bullish/bearish/neutral chip looks identical
// everywhere.

export function biasChipClass(bias: string): string {
  switch (bias) {
    case "bullish":
      return "border-emerald-500/40 text-emerald-400";
    case "bearish":
      return "border-red-500/40 text-red-400";
    default:
      return "border-border text-muted-foreground";
  }
}
